import { AuthService, FetchUtils } from '@yubi/yb-module-auth';
import { PRODUCT_CODES } from 'components/core/Constants';
import { getEnv } from 'components/core/Utils/envUtils';
import humps from 'humps';

export const fetchLoggedInUserDetails = () => {
    return FetchUtils.getJSON(
        `${getEnv(
            process.env.REACT_APP_AUTH_API_HOST
        )}/entities/${AuthService.getActiveEntityId()}/users/${AuthService.getActiveUserId()}?product_id=${
            PRODUCT_CODES.POOLS
        }`
    ).then((res) => humps.camelizeKeys(res));
};
